import React from "react";
import { useLang } from "@/context/LanguageContext";

export const LanguageToggle = () => {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid="lang-toggle"
      className="inline-flex items-center border border-border select-none"
    >
      <button
        data-testid="lang-toggle-fr"
        onClick={() => setLang("fr")}
        className={`px-3 py-1.5 text-xs font-bold tracking-wider transition-colors duration-200 ${
          lang === "fr"
            ? "bg-primary text-primary-foreground"
            : "bg-transparent text-muted-foreground hover:text-foreground"
        }`}
      >
        FR
      </button>
      <button
        data-testid="lang-toggle-en"
        onClick={() => setLang("en")}
        className={`px-3 py-1.5 text-xs font-bold tracking-wider transition-colors duration-200 ${
          lang === "en"
            ? "bg-primary text-primary-foreground"
            : "bg-transparent text-muted-foreground hover:text-foreground"
        }`}
      >
        EN
      </button>
    </div>
  );
};
